module.exports = __webpack_public_path__ + "media/nf_entity.78dde09b.mp4";